import React, { Component } from 'react';
import { General } from '../../common/constants';
import { debounce } from '../../common/utils';
import { isEmpty } from '../../common/utils';
import clsx from 'clsx';
import { standardInputClasses } from '../Elements/inputStyles';
import { Field, Label } from '../Catalyst/fieldset';
import { ClipLoader } from 'react-spinners';

class AutoComplete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            inputValue: props.value || ''
        };
        this.debouncedSearch = debounce(this.doSearch, General.Debounce.TypingMs);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ inputValue: this.props.value || '' });
        }
    }

    doSearch = (value, name) => {
        if (isEmpty(value)) {
            this.props.handleSearchChange(null, {
                value: null,
                text: null,
                name: name
            });
        } else {
            this.props.handleSearchChange(null, { value, name });
        }
    }

    handleResultSelect = (result) => {
        this.setState({
            isOpen: false,
            inputValue: result[this.props.textField] || ''
        });

        this.props.handleResultSelect(null, {
            value: result[this.props.valueField],
            text: result[this.props.textField],
            name: this.props.name
        });
    }

    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ 
            inputValue: value,
            isOpen: true 
        });
        this.debouncedSearch(value, this.props.name);
    }

    handleFocus = () => {
        this.setState({ isOpen: true });
    }

    handleBlur = (e) => {
        // Delay to allow click on result
        setTimeout(() => this.setState({ isOpen: false }), 200);
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    render() {
        const { loading, results = [], placeholder, label, requiredFlag, error, className } = this.props;
        const { isOpen, inputValue } = this.state;
        const shouldShowResults = isOpen && results.length > 0;

        return (
            <Field className={className}>
                {label && (
                    <Label>
                        {label}
                        {requiredFlag && <span className="text-red-500 dark:text-red-400 ml-1">*</span>}
                    </Label>
                )}
                <div className="relative mt-1">
                    <input
                        id={this.props.id}
                        name={this.props.name}
                        type="text"
                        value={inputValue}
                        onChange={this.handleSearchChange}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        placeholder={placeholder}
                        className={clsx(
                            standardInputClasses,
                            'w-full py-2 px-3 text-sm',
                            error && 'border-red-500'
                        )}
                    />
                    {loading && (
                        <div className="absolute right-3 top-1/2 -translate-y-[45%] z-50 pointer-events-none bg-surface">
                            <ClipLoader color="#6366f1" size={18} />
                        </div>
                    )}
                    
                    {shouldShowResults && (
                        <div className="absolute z-50 mt-1 w-full max-h-60 overflow-auto rounded-lg bg-surface dark:bg-zinc-800 shadow-lg border border-border dark:border-zinc-700">
                            {results.map((result, index) => (
                                <div
                                    key={index}
                                    onClick={() => this.handleResultSelect(result)}
                                    className="px-3 py-2 cursor-pointer hover:bg-surface-hover dark:hover:bg-zinc-700 text-sm"
                                >
                                    {this.props.resultRenderer ? this.props.resultRenderer({ result }) : result[this.props.textField]}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                {this.props.subTextVisible && (
                    <div className={this.props.subTextClass}>
                        {this.props.subText}
                    </div>
                )}
                {error && <p className="text-sm mt-1 text-text-error">{error}</p>}
            </Field>
        );
    }
}

export default AutoComplete;